module.exports = {"450381100":"荔城镇","450381101":"东昌镇","450381102":"新坪镇","450381103":"杜莫镇","450381104":"青山镇","450381105":"修仁镇","450381106":"大塘镇","450381107":"花箦镇","450381108":"双江镇","450381109":"马岭镇","450381200":"龙怀乡","450381201":"茶城乡","450381202":"蒲芦瑶族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450381.json
// module id = 2236
// module chunks = 0